module.exports = __webpack_public_path__ + "img/livreur_waiting.76b55352.svg";